module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "acknow"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/pppstranger006#toc"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("I suppose I will get used to this writing business someday but so far, for me, having a book published is still as close as it gets to being six years old on Christmas morning. My heartfelt thanks to The Poisoned Pen Press staff, to Robert Rosenwald, my publisher, and to my editor, Barbara Peters, who makes me write far better than I ever thought I could. Special thanks to Glenda Sibley who took on the daunting task of proofing and correcting these pages. To Susan who scours every manuscript for hitches and glitches, and all the folks who contributed to the development of this story. Thanks too, to Dick and Betsy Anderson, who introduced me to stranger rooms, and to the folks at Brownsburg, Virginia, who were willing to share their homes, friendship, and town.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b70ea1bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ppp-stranger007.vue
// module id = 75
// module chunks = 0